import classNames from "classnames";
import { forwardRef, ReactNode } from "react";
export interface ReviewModalItemProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
}
export const ReviewModalItem = forwardRef<HTMLDivElement, ReviewModalItemProps>(({
  title,
  children,
  className
}, ref) => <div ref={ref}>
      <div className="font-semibold">{title}</div>
      <div className={classNames("flex flex-col gap-2 rounded-lg border border-subtle p-4", className)}>{children}</div>
    </div>);
ReviewModalItem.displayName = "ReviewModalItem";